import { render, staticRenderFns } from "./DialogDetailFiles.vue?vue&type=template&id=3ef0be3e&"
import script from "./DialogDetailFiles.vue?vue&type=script&lang=ts&"
export * from "./DialogDetailFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports